import styled from 'styled-components'
import theme from 'styled-theming'

import Icon from '../Icon'
import {
  COLORS,
  CSS_ELEMENTS_RESETS,
  hoverSelector,
  THEME,
  typeScale,
} from '../../styles'

const VARIANT = {
  background: theme('variant', {
    secondary: THEME.COLORS.background.secondary,
    primary: THEME.COLORS.background.primary,
    powder: COLORS.powder,
  }),
  titleColor: theme('variant', {
    secondary: THEME.COLORS.foreground.primary,
    primary: THEME.COLORS.foreground.primary,
    powder: COLORS.black,
  }),
  subtitleColor: theme('variant', {
    secondary: THEME.COLORS.foreground.secondary,
    primary: THEME.COLORS.foreground.secondary,
    powder: COLORS.black,
  }),
}

const Styled = styled.div`
  background: ${VARIANT.background};
  padding-bottom: 2.4rem;
`
Styled.header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 2.4rem 2.4rem 0;
`
Styled.headerLeft = styled.div`
  flex: ${({ $hasHeaderRight }) => ($hasHeaderRight ? 'unset' : '1')};
`
Styled.headerRight = styled.div`
  flex: 1;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: start;
  flex-shrink: 0;
  padding: 0 1.6rem;
`
Styled.title = styled.p`
  ${typeScale('button')};
  text-align: left;
  color: ${VARIANT.titleColor};
`
Styled.subtitle = styled.p`
  ${typeScale('caption')};
  text-align: left;
  padding-top: 0.4rem;
  color: ${VARIANT.subtitleColor};
`
Styled.chevron = styled(Icon)`
  transform: ${({ $isOpen }) => `scaleY(${$isOpen ? '-1' : '1'})`};
  transform-origin: center;
  fill: ${VARIANT.titleColor};
  transition:
    transform 0.2s ease-out,
    fill 0.2s ease-out;
`
Styled.chevronButton = styled.button`
  ${CSS_ELEMENTS_RESETS.button};
  padding: 0.8rem;
  border-radius: 0.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${hoverSelector(Styled.chevron)`
    fill: ${COLORS.cobalt};
  `}
`
Styled.content = styled.div`
  max-height: 0;
  overflow: hidden;
  height: auto;
  width: 100%;
  transition: max-height 0.2s ease-out;
`
Styled.container = styled.div`
  width: 100%;
`

export default Styled
